import React from 'react';
import Tippy from '@tippyjs/react';

import { canEditCategory } from '../../utilities/permissionsUtilities';

import PageCategoryTitle from '../page/PageCategoryTitle';
import MoveSubcategoryWrapper from '../move/MoveSubcategoryWrapper';
import BookmarkItem from '../BookmarkItem';

import useCategories from '../../hooks/useCategories';
import CreateOrEditCategoryWrapper from '../create/CreateOrEditCategoryWrapper';
import DeleteCategoryWrapper from '../archive/DeleteCategoryWrapper';

const SubcategoryOptionDropdown = ({ subcategory }) => (
    <div className="dropdown dropdown-right-aligned" data-disclosure>
        <button className="btn rounded dropdown-link dropdown-elipsis">
            <img className="button-icon" height="20" width="auto" src="/img/icons/dropdown-elipsis.svg" />
        </button>
        <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
        <div data-details className="dropdown-content" style={{ display: 'none' }}>
            <BookmarkItem folderId={subcategory.id} bookmarkId={window.bookmarkId} />
            {canEditCategory() && <MoveSubcategoryWrapper subcategory={subcategory} text="Move subcategory" />}
            {canEditCategory()
            && (
                <CreateOrEditCategoryWrapper folder_id={subcategory.id} category_id={subcategory.category_id}>
                    <span className="dropdown-option link">Edit subcategory</span>
                </CreateOrEditCategoryWrapper>
            )}
            {canEditCategory() && <DeleteCategoryWrapper category={subcategory} />}
            <a className="dropdown-option do-cancel">Cancel</a>
        </div>
    </div>
);

const SubcategoryVisibility = ({ subcategory }) => {
    const { visibility_text, visibility_description } = subcategory;

    return (
        <div className="flex-none flex">
            <Tippy content={visibility_description} placement="bottom">
                <div className="page-visibility">
                    { visibility_text }
                </div>
            </Tippy>
            <div className="flex-none">
                <SubcategoryOptionDropdown subcategory={subcategory} />
            </div>
        </div>
    );
};

const LoadingHeader = () => (
    <div className="page-top flex-none mb3">
        <div className="flex-auto flex gray" />
        <div className="flex-none flex no-select mr1 sm-show" style={{ marginTop: 4 }} />
        <div className="flex-none flex no-select" />
        <div className="flex-none no-select" />
    </div>
);

const SubcategoryHeader = ({ subcategory }) => {
    const { id: folder_id, category_id, parents = [] } = subcategory;

    const categories = useCategories();
    if (!categories) return <LoadingHeader />;

    return (
        <div className="page-top flex-none">
            <div className="flex-auto flex gray">
                { category_id && <PageCategoryTitle categoryId={category_id} folderId={folder_id} parents={parents} /> }
            </div>
            <div className="flex-none flex">
                <SubcategoryVisibility subcategory={subcategory} />
            </div>
        </div>
    );
};

export default SubcategoryHeader;
